import { ColDef } from 'ag-grid-enterprise';

export const getAdjustmentBRReviewColumnDefs = (
    originalEffDate: string,
    currentEffDate: string,
    endorsementEffDate: string,
    readOnly: boolean
): ColDef[] => [
    ...[
        {
            headerName: `Original Submission\n${originalEffDate}`,
            field: 'origValue',
            minWidth: 150,
            flex: 1,
            valueFormatter: ({ value }: any) => value || '-',
        },
        {
            headerName: `Current\n${currentEffDate}`,
            field: 'currentValue',
            minWidth: 180,
            flex: 1,
            valueFormatter: ({ value }: any) => value || '-',
        },
    ],
    // Only include Updated column if we're not in readOnly mode (meaning the review is not yet bound)
    ...(!readOnly
        ? [
              {
                  headerName: `Updated\n${endorsementEffDate}`,
                  field: 'updatedValue',
                  minWidth: 150,
                  flex: 1,
                  valueFormatter: ({ value }: any) => value || '-',
              },
          ]
        : []),
];

export const defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
    sortable: true,
};
